import React from 'react';
import {
  Checkbox as Checkbox1
} from "react-inputs-validation";





const Checkbox = ({ id,
  type,
  input,
  value,
  name,
  placeholder,
  onChange,
  validationCallback,
  maxLength,
  minLength,
  length,
  required,
  reg,
  mensajeError,
  validate,
  min,
  max
}) => {


  return (
    <div>
      <Checkbox1
        id={id} // Optional.[String].Default: "".  Input ID.
        name={name} // Optional.[String].Default: "". Input name
        //value={value} // Required.[String].Default: "".
        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
        checked={value} // Required.[Bool].Default: false.
        onChange={(isAgreementChecked, e) => {
          onChange(isAgreementChecked)
          console.log('verCheck',isAgreementChecked)
        }}

      />
    </div>

  );
};

export default Checkbox;
